import { useCallback, useEffect, useRef, useState } from 'react';

interface Props {
    isOpen: boolean;
    onClose?: () => void;
}

export const useSidePanelOpenState = ({ isOpen, onClose }: Props) => {
    const didRenderRef = useRef(false);
    const [internalIsOpen, setInternalIsOpen] = useState(false);

    useEffect(() => {
        if (!didRenderRef.current) {
            setTimeout(() => {
                setInternalIsOpen(isOpen);
                didRenderRef.current = true;
            });
            return;
        }
        setInternalIsOpen(isOpen);
    }, [isOpen]);

    const closeSidePanel = useCallback(() => {
        setInternalIsOpen(false);
    }, []);

    const onTransitionEnd = useCallback(() => {
        if (!internalIsOpen) {
            onClose?.();
        }
    }, [internalIsOpen, onClose]);

    return { closeSidePanel, internalIsOpen, onTransitionEnd };
};
